module.exports = __webpack_public_path__ + "img/sage_logo.167314d3.png";